import { Component } from '@angular/core';
import { YATTA_ACADEMIC_PROGRAM_TERMS_URL } from '@platform-frontend/platform';

@Component({
  selector: 'yat-terms-note',
  templateUrl: './terms-note.component.html',
  styleUrls: ['./terms-note.component.scss']
})
export class TermsNoteComponent {
  readonly ACADEMIC_PROGRAM_TERMS_URL = YATTA_ACADEMIC_PROGRAM_TERMS_URL;
}
